import { requireService } from '@profgeosoft/di-ez';
import { TableCheckbox as TableCheckboxFromUI, type GridRenderCellParams } from '@profgeosoft-ui/table';

import { wrap } from 'src/packages/mobx-di/wrap';

import type { DirectoryRecord } from 'src/services/directory-service/entities/directory-record.entity';
import type { TControlView } from 'src/services/directory-service/types';

import { Cell } from './cell/cell';

type Props = {
  params: GridRenderCellParams<DirectoryRecord>;
  columnView: TControlView;
};

export const TableCheckbox = wrap<Props>(function TestCheckbox({ params, columnView }) {
  const directoryPage = requireService('directoryPage');
  const directory = directoryPage.currentDirectory;

  return (
    <Cell message={undefined}>
      <TableCheckboxFromUI
        cellParams={params}
        checked={params.value}
        disabled={!directoryPage.isEditing}
        onChange={(value) => {
          directory?.directoryViewMediator?.onControlValueChange(params.row.recordId, columnView.fieldId, value);
        }}
      />
    </Cell>
  );
});
